<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: 'app',
  components: {
  },
  created () {
    if (window.location.hash.indexOf('preview') == -1 && !window.location.search) {
        this.$store.dispatch('LOGIN')
    }
  }
}
</script>
<style>
#app{
  min-width: 1200px;
  height: 100%;
}
</style>




// WEBPACK FOOTER //
// module/magicCube/src/App.vue